import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import Delete from "./Delete";
const Card = (props) => {
  const [deleteUrl, setDeleteUrl] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const openInNewTab = () => {
    window.open(props.stat.url, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <div class="AdminFormImageContainer">
        <div class="AdminFormImageContainerImage">
          <img src={props.stat.url} alt="School Schedule Four" />
        </div>
        <div class="AdminFormImageContainerButton">
          <Button
            circular
            icon="trash"
            color="red"
            name="editedButton"
            className="right floated"
            onClick={() => {
              setDeleteUrl(props.stat.url);
              setDeleteId(props.id);
            }}
          />

          <Button
            circular
            icon="eye"
            color="blue"
            className="right floated"
            name="editedButton"
            onClick={openInNewTab}
          />
        </div>
        {deleteUrl && deleteId && (
          <Delete
            deleteUrl={deleteUrl}
            deleteId={deleteId}
            close={() => {
              setDeleteId(null);
              setDeleteUrl(null);
            }}
          />
        )}
      </div>
    </>
  );
};

export default Card;
